import { useState, useEffect } from 'react'
import toast from 'react-hot-toast'

const DEFAULT_PREFERENCES = {
  newChat: true,
  newMessage: true,
  email: true,
  sound: true,
  desktop: true,
  emailDigest: false
}

export const useNotificationPreferences = () => {
  const [preferences, setPreferences] = useState(() => {
    const stored = localStorage.getItem('notification-preferences')
    return stored ? JSON.parse(stored) : DEFAULT_PREFERENCES
  })

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    localStorage.setItem('notification-preferences', JSON.stringify(preferences))
  }, [preferences])

  const updatePreference = async (key, value) => {
    setIsLoading(true)
    try {
      setPreferences(prev => ({
        ...prev,
        [key]: value
      }))
      
      // If enabling desktop notifications, request permission
      if (key === 'desktop' && value && 'Notification' in window) {
        if (Notification.permission === 'default') {
          const permission = await Notification.requestPermission()
          if (permission !== 'granted') {
            setPreferences(prev => ({
              ...prev,
              desktop: false
            }))
            toast.error('Desktop notifications permission denied')
            return
          }
        }
      }
      
      toast.success('Notification preference updated')
    } catch (error) {
      toast.error('Failed to update preference')
      // Revert the change
      setPreferences(prev => ({
        ...prev,
        [key]: !value
      }))
    } finally {
      setIsLoading(false)
    }
  }

  const resetToDefaults = () => {
    setPreferences(DEFAULT_PREFERENCES)
    toast.success('Preferences reset to defaults')
  }

  return {
    preferences,
    updatePreference,
    resetToDefaults,
    isLoading
  }
}